<template>
	<div>
		<header class="sticky top-0 z-50">
			<div class="bg-white shadow py-4 relative z-10">
				<div class="container mx-auto px-4 flex items-center text-xl uppercase text-gray-700 flex-col sm:flex-row sm:justify-between sm:items-center md:px-8 lg:text-lg xl:text-xl">
					<img class="h-6 mx-auto sm:h-8 sm:mx-0 lg:h-10" :src="require('@/assets/dish-outdoors.svg')">
					<a class="mt-4 text-dish-red font-bold leading-none sm:mt-0 sm:text-3xl lg:text-4xl" :href="phoneUrl">{{ phoneNumber }}</a>
				</div>
			</div>
		</header>

		<main class="container mx-auto shadow bg-white">
			<section class="relative text-white">
				<img class="hidden absolute h-full bottom-0 right-0 z-20 lg:block" :src="require('@/assets/influencer/Eye-Catcher.png')">
				<div class="relative z-10">
					<div class="px-4 py-8 text-center bg-cover bg-center lg:px-8 lg:py-16 lg:text-left" :style="`background-image: url(${require('@/assets/influencer/Background.jpg')});`">
						<h2 class="text-3xl leading-none font-bold max-w-2xl mx-auto sm:text-5xl md:max-w-xl lg:ml-0 lg:text-6xl lg:font-semibold xl:max-w-3xl xl:text-7xl">TV That Travles With You</h2>
						<p class="text-xl leading-tight mt-2 sm:text-3xl lg:text-2xl">No Wi-Fi or cell signal needed!</p>
						<a href="#learn-more" class="mt-8 inline-block bg-dish-red py-2 px-4 font-semibold rounded sm:text-xl">Learn More</a>
					</div>
					<div class="bg-dish-red px-4 py-2 z-10 lg:px-8">
						<div class="flex items-center lg:max-w-xl xl:max-w-3xl">
							<div class="flex-shrink-0 mr-4 xl:mr-8">
								<img class="h-16 sm:h-24" :src="logo">
							</div>
							<div class="flex-grow">
								<h3 class="leading-none text-lg font-semibold sm:text-2xl md:text-3xl xl:text-4xl xl:max-w-md">Exclusive Offer For Friends Of {{ name }}</h3>
								<p class="leading-tight mt-1 sm:text-xl md:text-2xl lg:text-xl xl:text-2xl">Save <span class="price">{{ amount }}</span> on a DISH satellite antenna bundle</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="px-4 py-8 relative sm:py-12">
				<div class="leading-none text-center md:hidden">
					<p class="text-3xl sm:text-4xl xl:text-5xl">Get Started With</p>
					<p class="price text-7xl text-dish-red font-bold">{{ amount }} Off</p>
					<p class="text-xl sm:text-4xl xl:text-5xl">Any Dish Satellite Antenna Bundle</p>
				</div>

				<div class="flex flex-col md:flex-row md:items-center">
					<div class="mt-4 md:w-1/2 md:mr-2">
						<img class="mx-auto max-w-xs w-full sm:max-w-md md:max-w-full" :src="require('@/assets/trucking/bundle.png')">
					</div>
					<div class="mt-4 mx-auto w-full max-w-sm sm:max-w-full md:w-1/2 md:ml-2">
						<div class="leading-none text-center hidden mb-8 md:block">
							<p class="text-3xl sm:text-4xl xl:text-5xl">Get Started With</p>
							<p class="price text-7xl text-dish-red font-bold">{{ amount }} Off</p>
							<p class="text-xl sm:text-4xl">Any Dish Satellite Antenna Bundle</p>
						</div>

						<div class="text-center border-4 border-dashed border-black py-2 px-4">
							<p class="leading-tight sm:text-xl">Use Code At Checkout: <span class="block font-bold text-2xl text-dish-red tracking-wide sm:text-4xl">{{ coupon }}</span></p>
						</div>

						<div class="text-center mt-4">
							<a :href="`https://www.dishformyrv.com/bundles/?st-t=${tfn}&utm_medium=RVinfluencers&utm_campaign=${name}&utm_source=dishoutdoors`" class="font-bold text-white bg-dish-red py-1 px-3 inline-block mx-auto mt-2 rounded text-xl lg:text-2xl lg:mt-4">Shop Now</a>
						</div>
					</div>
				</div>
			</section>

			<section class="px-4 pt-16 pb-4 text-center sm:pt-24 md:pb-12 lg:py-12 relative">
				<div id="learn-more" class="absolute top-0 -mt-2 lg:-mt-12"></div>
				<h1 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">DISH Outdoors In 3 Easy Steps</h1>
				<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl sm:max-w-md sm:mx-auto lg:max-w-full">Your way to take TV outside whenever and where you want to!</p>

				<flickity ref="steps" class="steps-flickity -mx-4 mt-8 pb-5 md:flex md:px-8 md:mt-0 md:flex-col lg:flex-row" :options="flickityOptions">
					<a href="#antenna" class="w-3/4 py-8 mx-2 md:pt-0 md:w-1/2 md:mx-auto md:mt-8 md:pb-0 lg:w-1/3 lg:mx-4">
						<div class="shadow-md relative pb-4 xl:h-full">
							<div class="relative" @click.prevent.stop>
								<video @loadedmetadata="resizeSteps" preload="auto" ref="antennaVideo" controls src="https://get.dishformyrv.com/hubfs/Trucking/assets/videos/Satellite%20Antenna%20Options.mp4"></video>
								<div @click="startVideo('antennaVideo')" v-if="!hasPlayed['antennaVideo']" class="absolute inset-0 flex justify-center items-center bg-black">
									<div class="absolute inset-0">
										<img class="w-full h-full" src="https://get.dishformyrv.com/hubfs/dishoutdoors/images/satellite-antenna-thumbnail.jpg">
									</div>
									<div class="absolute inset-0 bg-black opacity-50"></div>
									<svg class="h-10 w-10 relative border-4 text-white rounded-full" viewBox="0 0 48 48" stroke="currentColor" stroke-width="4" fill="none">
										<polygon points="32 24, 16 16, 16 32"></polygon>
									</svg>
								</div>
							</div>
							<div class="px-4 py-4">
								<div class="absolute bottom-0 w-full left-0 flex justify-center -mb-4">
									<p class="-mb-1 text-2xl font-bold bg-dish-red text-white rounded-full w-8 h-8 flex justify-center items-center flex-shrink-0 lg:h-10 lg:w-10 lg:text-3xl">1</p>
								</div>
								<div class="flex justify-center items-center lg:items-start">
									<h3 class="tracking-tight text-lg font-bold leading-none lg:text-xl xl:text-2xl xl:max-w-xs">Choose a DISH-compatible satellite antenna.</h3>
								</div>
								<p class="leading-tight mt-2 xl:text-xl">Portable, automatic, HD satellite antennas for your adventures.</p>
							</div>
						</div>
					</a>
					<a href="#wally" class="w-3/4 py-8 mx-2 md:pt-0 md:w-1/2 md:mx-auto md:mt-8 md:pb-0 lg:w-1/3 lg:mx-4">
						<div class="shadow-md relative pb-4 xl:h-full">
							<div class="relative" @click.prevent.stop>
								<video @loadedmetadata="resizeSteps" preload="auto" ref="wallyVideo" controls src="https://get.dishformyrv.com/hubfs/Trucking/assets/videos/DISH%20Wally%20and%20Accessories.mp4"></video>
								<div @click="startVideo('wallyVideo')" v-if="!hasPlayed['wallyVideo']" class="absolute inset-0 flex justify-center items-center">
									<div class="absolute inset-0">
										<img class="w-full h-full" src="https://get.dishformyrv.com/hubfs/dishoutdoors/images/wally-thumbnail.jpg">
									</div>
									<div class="absolute inset-0 bg-black opacity-50"></div>
									<svg class="h-10 w-10 relative border-4 text-white rounded-full" viewBox="0 0 48 48" stroke="currentColor" stroke-width="4" fill="none">
										<polygon points="32 24, 16 16, 16 32"></polygon>
									</svg>
								</div>
							</div>
							<div class="px-4 py-4">
								<div class="absolute bottom-0 w-full left-0 flex justify-center -mb-4">
									<p class="-mb-1 text-2xl font-bold bg-dish-red text-white rounded-full w-8 h-8 flex justify-center items-center flex-shrink-0 lg:h-10 lg:w-10 lg:text-3xl">2</p>
								</div>
								<div class="flex justify-center items-center lg:items-start">
									<h3 class="tracking-tight text-lg font-bold leading-none lg:text-xl xl:text-2xl xl:max-w-xs">Add a DISH Wally® HD receiver.</h3>
								</div>
								<p class="leading-tight mt-2 xl:text-xl">Bundle a receiver with your antenna for even more savings.</p>
							</div>
						</div>
					</a>
					<a href="#programming" class="w-3/4 py-8 mx-2 md:pt-0 md:w-1/2 md:mx-auto md:mt-8 md:pb-0 lg:w-1/3 lg:mx-4">
						<div class="shadow-md relative pb-4 xl:h-full">
							<div class="relative" @click.prevent.stop>
								<video @loadedmetadata="resizeSteps" preload="auto" ref="paygVideo" controls src="https://get.dishformyrv.com/hubfs/Trucking/assets/videos/Pay%20As%20You%20Go.mp4"></video>
								<div @click="startVideo('paygVideo')" v-if="!hasPlayed['paygVideo']" class="absolute inset-0 flex justify-center items-center">
									<div class="absolute inset-0">
										<img class="w-full h-full" src="https://get.dishformyrv.com/hubfs/dishoutdoors/images/paygo-thumbnail.jpg">
									</div>
									<div class="absolute inset-0 bg-black opacity-50"></div>
									<svg class="h-10 w-10 relative border-4 text-white rounded-full" viewBox="0 0 48 48" stroke="currentColor" stroke-width="4" fill="none">
										<polygon points="32 24, 16 16, 16 32"></polygon>
									</svg>
								</div>
							</div>
							<div class="px-4 py-4">
								<div class="absolute bottom-0 w-full left-0 flex justify-center -mb-4">
									<p class="-mb-1 text-2xl font-bold bg-dish-red text-white rounded-full w-8 h-8 flex justify-center items-center flex-shrink-0 lg:h-10 lg:w-10 lg:text-3xl">3</p>
								</div>
								<div class="flex justify-center items-center lg:items-start">
									<h3 class="tracking-tight text-lg font-bold leading-none lg:text-xl xl:text-2xl xl:max-w-xs">Call <a class="inline-block text-dish-red" :href="phoneUrl">{{ phoneNumber }}</a> to activate.</h3>
								</div>
								<p class="leading-tight mt-2 xl:text-xl">Pay As You Go from $42.99/mo*, with no contracts or commitments.</p>
							</div>
						</div>
					</a>
				</flickity>
			</section>

			<aside class="py-4 px-6 text-gray-900 lg:flex" style="background-color: #eee;">
				<div class="mx-auto max-w-lg lg:w-2/5">
					<div class="relative">
						<p class="text-dish-red text-7xl absolute top-0 left-0 -ml-6 leading-none -mt-8 opacity-15 sm:-ml-10" style="transform:scale(3); transform-origin:top left;">&#8220;</p>
						<p class="pl-2 relative font-medium tracking-wide sm:text-xl italic lg:text-lg">The DISH Outdoors service is the best thing going for RVers. So easy to start, stop, and set up. And good support. We have recommended it to several RVers.</p>
					</div>
					<div class="mt-2 flex items-center">
						<p class="ml-auto font-semibold">&ndash; Jody M, Idaho</p>
					</div>
				</div>
				<div class="hidden mx-auto max-w-lg lg:w-2/5 lg:block">
					<div class="relative">
						<p class="text-dish-red text-7xl absolute top-0 left-0 -ml-6 leading-none -mt-8 opacity-15 sm:-ml-10" style="transform:scale(3); transform-origin:top left;">&#8220;</p>
						<p class="pl-2 relative font-medium tracking-wide sm:text-xl italic lg:text-lg">We love our DISH Outdoors for our camper. Great value and price and we LOVE that we are not in contract and can turn off and on as we please..</p>
					</div>
					<div class="mt-2 flex items-center">
						<p class="ml-auto font-semibold">&ndash; Lisa R, Nebraska</p>
					</div>
				</div>
			</aside>

			<section class="bg-dish-red text-white px-4 py-3 justify-center text-center leading-tight font-semibold text-3xl md:text-4xl md:py-2 lg:text-5xl">
				<p><span class="font-bold">Step 1:</span> Choose An Antenna</p>
			</section>

			<section class="px-4 py-8 text-center sm:py-12 relative">
				<div id="antenna" class="absolute top-0 -mt-14 lg:-mt-12"></div>
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Use Code <span class="text-dish-red font-bold">{{ coupon }}</span> </h2>
				<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl">for <span class="price">{{ amount }}</span> off of any of these satellite antenna bundles!</p>
				<flickity ref="antennas" class="antennas-flickity -mx-4 mt-4 lg:flex lg:mt-4" :options="flickityOptions">
					<div class="w-5/6 py-4 px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0" v-for="(antenna, index) in antennas" :key="index">
						<div class="shadow py-2 h-full lg:shadow-none">
							<img @load="$refs['antennas'].resize()" class="mx-auto lg:w-3/4" :src="antenna.img">
							<div class="px-4 pb-2 mt-4 flex flex-col leading-tight" :class="index == 0 ? '' : 'lg:border-l-2 border-gray-700'">
								<h4 class="font-bold text-xl xl:text-2xl">{{ antenna.name }}</h4>
								<p class="text-lg mt-2 xl:text-xl">Automatic signal finder</p>
								<p class="text-lg mt-2 xl:text-xl">{{ antenna.tagline }}</p>
								<p class="text-lg mt-2 mb-auto xl:text-xl">{{ antenna.tvs }} TV Option</p>
								<p class="price text-dish-red text-5xl my-2 xl:text-6xl">{{ antenna.price }}</p>
								<a :href="`${antenna.link}?st-t=${tfn}&utm_medium=RVinfluencers&utm_campaign=${name}&utm_source=dishoutdoors`" class="text-white bg-dish-red py-2 px-4 rounded font-semibold mx-auto xl:text-xl">Shop Now</a>
							</div>
						</div>
					</div>
				</flickity>
			</section>

			<section class="bg-dish-red text-white px-4 py-3 justify-center text-center leading-tight font-semibold text-3xl md:text-4xl md:py-2 lg:text-5xl">
				<p><span class="font-bold">Step 2:</span> Add The Wally HD Receiver</p>
			</section>

			<section class="px-4 text-center py-4 sm:py-12 sm:px-8 relative">
				<div id="wally" class="absolute top-0 -mt-12 lg:-mt-20"></div>
					<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Great TV For The Great Outdoors</h2>
					<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl">The DISH Wally HD receiver will enhance your entertainment experience!</p>

					<div class="flex mt-4 items-center flex-col lg:flex-row lg:mt-8">
						<div class="lg:px-8 lg:w-1/2">
							<img class="sm:w-2/3 sm:mx-auto lg:w-full" :src="require('@/assets/Wally.png')">
						</div>
						<div class="text-center mt-4 md:px-4 lg:px-8 lg:mt-0 lg:w-1/2 lg:text-left">
							<h4 class="font-bold leading-none text-xl sm:text-2xl text-left">Meet the DISH Wally HD Receiver</h4>
							<p class="mt-2 sm:text-lg text-left">Connect the Wally to your portable antenna and begin enjoying your TV no matter where you are. With built in apps, channel search features, and Bluetooth capability, Wally gives you the comforts of DISH at home, on the go!</p>
							<a :href="`https://get.dishformyrv.com/dish-wally-hd-receiver?st-t=${tfn}&utm_medium=RVinfluencers&utm_campaign=${name}&utm_source=dishoutdoors`" class="bg-dish-red text-white py-2 px-4 inline-block font-semibold rounded mt-4 mx-auto sm:text-xl sm:mt-8 lg:py-1 lg:text-lg lg:mt-4">Learn More</a>
					</div>
				</div>
			</section>

			<section class="bg-dish-red text-white px-4 py-3 justify-center text-center leading-tight font-semibold text-3xl md:text-4xl md:py-2 lg:text-5xl">
				<p><span class="font-bold">Step 3:</span> Select Programming and Call To Activate</p>
			</section>

			<section class="py-4 px-4 text-center sm:py-12 sm:pb-12 md:px-8 relative">
				<div id="programming" class="absolute top-0 -mt-14 lg:-mt-24"></div>
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Flexible HD TV Programming</h2>
				<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl">Pay As You Go programming packages with no contracts or commitments!</p>

				<div class="channelboxes mt-8 -mx-4 md:-mx-8 lg:px-8">
					<channel-boxes/>
				</div>
			</section>

			<aside class="px-4 text-gray-900 pb-1" style="background-color: #eee;">
                <div class="container md:flex md:flex-row mx-auto justify-between">
                    <div class="bg- flex-1 p-2 pt-0 sm:flex items-center sm:pt-2">
                        <div class="w-32 flex-none mx-auto sm:mx-0">
                            <img class="" src="https://get.dishformyrv.com/hubfs/bc/homepage/img/awards/motor-home.png">
                        </div>

                        <p class="font-montserrat font-normal max-w-xs mx-auto sm:max-w-full sm:ml-2 sm:mr-0">
                            MotorHome magazine awarded DISH gold in the 2019 Reader’s Choice Award for the RV satellite provider category.
                        </p>
                    </div>
                    <div class="bg- flex-1 hidden md:flex p-2 items-center">
                        <div class="w-32 flex-none">
                            <img class="" src="https://get.dishformyrv.com/hubfs/bc/homepage/img/awards/trailer-life.png">
                        </div>

                        <p class="font-montserrat ml-2 font-normal m-0">
                            DISH won gold in the RV satellite provider category for the 2019 Trailer Life Reader’s Choice Award.
                        </p>
                    </div>
                </div>
            </aside>

			<section class="py-4 px-4 sm:py-12 md:px-8">
				<div class="text-center">
					<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Frequently Asked Questions</h2>
					<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl">Still have questions? We've got answers.</p>
				</div>
				<div class="flex mt-6">
					<div class="w-full md:pr-2 md:w-1/2">
						<details v-for="(faq, index) in faqs" :key="index" class="w-full sm:text-lg bg-white shadow overflow-hidden" :class="{
							'rounded-t': index === 0,
							'rounded-b': index === faqs.length - 1,
							'md:hidden': index > faqs.length / 2 - 1,
							'md:rounded-b': index === faqs.length / 2 - 1,
						}">
							<summary class="text-lg font-semibold text-gray-900 py-2 px-4 xl:text-xl" style="background-color: #eee;">{{ faq.question }}</summary>
							<p class="py-4 px-4" v-html="faq.answer"></p>
						</details>
					</div>
					<div class="hidden pl-2 w-1/2 md:block">
						<details v-for="(faq, index) in faqs" :key="index" class="w-full sm:text-lg bg-white shadow overflow-hidden" :class="{
							'rounded-t': index === 0,
							'rounded-b': index === faqs.length - 1,
							'md:hidden': index < faqs.length / 2,
							'md:rounded-t': index === faqs.length / 2,
						}">
							<summary class="text-lg font-semibold text-gray-900 py-2 px-4 xl:text-xl" style="background-color: #eee;">{{ faq.question }}</summary>
							<p class="py-4 px-4" v-html="faq.answer"></p>
						</details>
					</div>
				</div>

				<div class="flex justify-center mt-8">
					<a class="text-center bg-dish-red text-white py-1 px-4 rounded font-semibold text-lg" href="https://get.dishformyrv.com/outdoor-satellite-tv/frequently-asked-questions">See All Questions</a>
				</div>
			</section>

			<section class="bg-dish-red py-4">
				<img class="h-8 w-auto mx-auto" :src="require('@/assets/dish-outdoors-white.svg')">
			</section>
		</main>
	</div>
</template>

<script>
	import axios from 'axios'
	import ChannelBoxes from 'channel-boxes'
	import cookies from 'js-cookie'
	import Flickity from 'vue-flickity'

	const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	const formEndpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/1846077/f800eb8d-2dba-4213-b65d-a8ee45a18872'
	
	export default {
		components: {
			ChannelBoxes,
			Flickity,
		},

		computed: {
			phoneUrl() {
				return `tel:${this.phoneNumber}`
			}
		},

		data() {
			return {
				antennas: [
					{ img: require('@/assets/Playmaker.png'), name: 'DISH Playmaker®', tagline: 'Compact and lightweight', tvs: 1, price: 348, link: 'https://www.dishformyrv.com/new-dish-playmaker-bundle-with-wally/' },
					{ img: require('@/assets/Tailgater.png'), name: 'DISH Tailgater®', tagline: 'Portable and mountable', tvs: 1, price: 398, link: 'https://www.dishformyrv.com/dish-tailgater-satellite-antenna-bundle-with-wally/' },
					{ img: require('@/assets/Tailgater-Pro.png'), name: 'DISH Tailgater® Pro', tagline: '100% Nationwide coverage', tvs: 2, price: 448, link: 'https://www.dishformyrv.com/dish-tailgater-pro-satellite-antenna-bundle-with-wally/' },
					{ img: require('@/assets/x2.png'), name: 'Pathway® X2', tagline: 'Best option for East Coast', tvs: 2, price: 548, link: 'https://www.dishformyrv.com/winegard-pathway-x2-bundle-with-wally/' },
				],

				flickityOptions: {
					groupCells: true,
					pageDots: false,
					watchCSS: true,
				},
				
				videoPlaying: null,
				hasPlayed: {
					antennaVideo: false,
					wallyVideo: false,
					paygVideo: false,
				},

				email: '',
				invalidEmail: false,
				formError: false,
				formSubmitted: false,
				submitting: false,

				faqs: [
					{ question: 'What are your payment options?', answer: 'We have programming options to suit any budget, you can check them out <a class="underline text-dish-red" href="https://get.dishformyrv.com/#Programming">here</a>.' },
					{ question: 'Which antenna is right for me?', answer: 'We have plenty of options to fit your travel needs! We even have <a class="underline text-dish-red" href="https://get.dishformyrv.com/satellite-antenna-quiz">a helpful quiz</a> to narrow things down for you.', },
					{ question: 'I already have DISH at home, how can I get it for my RV?', answer: 'Thank you for being a DISH customer! First purchase a DISH mobile receiver and compatible antenna, then you can add your new receiver directly to your existing account. <a class="underline text-dish-red" href="https://dishformyrv.com/bundles/">Check out our bundle packages.' },
					{ question: 'Do I need DISH at home to get DISH Outdoors?', answer: 'No, you can set up a Pay As You Go (month to month) Account starting at $42.99.' },
					{ question: 'How do I get locals in my area?', answer: 'If you are DISH customer at home, call 1-800-333-3474 to change your location. If you have an Outdoor Account you can change your locals on the <a class="underline text-dish-red" href="https://my.dish.com/app">MyDISH app</a>.' },
					{ question: 'Does an installer come out and set this up?', answer: 'DISH Outdoors equipment is easy to self-install, or you can <a href="https://get.dishformyrv.com/outdoor-satellite-tv/dealer" class="underline text-dish-red">contact your local RV Dealer</a>.' },
					{ question: 'How much does DISH Outdoors cost?', answer: 'If you are currently a DISH customer at home, adding a receiver to your RV is only $7/month after purchase of equipment. If you are not currently a customer, we have channel packages starting at $42.99/month. With Pay As You Go, you only pay for the months you plan on traveling!' },
					{ question: 'How does the Pay As You Go program work?', answer: 'Pay As You Go allows you to pay on a month-by-month basis - perfect for traveling! Just activate when you hit the road, and when you are no longer using your service you can simply stop making your monthly payment.' },
					{ question: 'Can I activate service for a week at a time?', answer: 'All Pay As You Go packages are billed in 30 day increments.' },
					{ question: 'Will these antennas work with my existing DISH receiver?', answer: 'DISH mobile receiver models are listed as follows. Wally, ViP 211z, ViP 211k, ViP 211, ViP 411. These receivers are required in order to operate a mobile satellite antenna.' },
				]
			}
		},

		methods: {
			submitForm() {
				this.formError = false

				if (!emailRegex.test(this.email) || this.submitting) {
					this.invalidEmail = true
					return
				}

				this.submitting = true
				
				axios.post(formEndpoint, {
					fields: [
						{ name: 'email', value: this.email },
					],

					context: {
						hutk: cookies.get('hubspotutk'),
					},

					pageTitle: document.title,
					pageUri: document.URL,
				}).then(() => {
					this.formSubmitted = true
				}).catch(() => {
					this.formError = true
					this.submitting = false
				})
			},
			
			pauseVideo(video) {
				if (video === this.videoPlaying) {
					this.videoPlaying = null
					this.$refs[video].pause()
				}
			},

			resizeSteps() {
				this.$refs['steps'].resize()
			},
			
			startVideo(video) {
				this.$refs['antennaVideo'].pause()
				this.$refs['wallyVideo'].pause()
				this.$refs['paygVideo'].pause()
				this.$nextTick(() => {
					this.videoPlaying = video
					this.hasPlayed[video] = true
					this.$refs[video].play()
				})
			},
		},

		props: {
			amount: {
				required: false,
				default: '50',
			},

			coupon: {
				required: true,
			},

			logo: {
				required: true,
			},

			name: {
				required: true,
			},

			phoneNumber: {
				required: false,
				default: '1-877-650-9634',
			},

			tfn: {
				required: false,
				default: 'ABDR',
			},
		},

		watch: {
			email() {
				if (this.invalidEmail) {
					this.invalidEmail = !emailRegex.test(this.email)
				}
			},
		},
	}
</script>

<style src="channel-boxes/lib/channel-boxes.css"/>

<style scoped>
	.object-cover.object-center {
		@apply object-cover object-center;
	}

	.price::before {
		content: '$';
		font-size: .5em;
		vertical-align: super;
	}

	input::placeholder {
		@apply text-gray-600;
	}

	.submitting {
		@apply text-transparent relative !important;
	}

	.submitting::after {
		@apply absolute border-4 border-dish-red w-6 h-6 rounded-full;

		content: ' ';
		left: calc(50% - .75rem);
		top: calc(50% - .75rem);
		border-color: #f0144644;
		border-top-color: #f01446;
		animation: spinning 1.5s ease-in-out 0s infinite;
	}

	@keyframes spinning {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(720deg);
		}
	}

	.steps-flickity::after {
		content: 'flickity';
		display: none;
	}

	.antennas-flickity::after {
		content: 'flickity';
		display: none;
	}

	@screen md {
		.steps-flickity::after {
			content: '';
		}
	}

	@screen lg {
		.antennas-flickity::after {
			content: '';
		}
	}
</style>
